import Swal from "sweetalert2";

export function deletePopup(item) {
  return base({
    title: `${item.name} 님을 목록에서 삭제하시겠습니까?`,
    confirmButtonText: "네",
    cancelButtonText: "취소하기",
    icon: "warning",
  }).then((result) => {
    if (result.isConfirmed) {
      return true;
    }

    return false;
  });
}

function base(descriptions) {
  return Swal.fire({
    title: descriptions.title,
    html: descriptions.html,
    confirmButtonText: descriptions.confirmButtonText,
    cancelButtonText: descriptions.cancelButtonText,
    icon: descriptions.icon,
    showCancelButton: true,
    confirmButtonColor: "orange",
    buttonsStyling: true,
    preConfirm: descriptions.preConfirm
  });
}

export function success() {
  return Swal.fire({
    title: "완료하였습니다",
    icon: "success",
    iconColor: "orange",
    confirmButtonClass: "md-button md-success btn-fill",
    confirmButtonColor: "orange",
    buttonsStyling: true,
  });
}
